import React, {useEffect, useState} from 'react';
import BackServer from "../../api/BackServer";
import {Image, Spin, Tag} from "antd";
import { LoadingOutlined } from '@ant-design/icons';
const QueDetail = (props) => {
    const [orderDetails, setOrderDetails]=useState(props.dta);
    // alert(props.dta)
    // useEffect(() => {
    //     const fetchDetails = async () => {
    //         try {
    //             console.log(props.dta)
    //             const data = await BackServer.get_orderDetails(props.dta.uuid,props.dta.comments_amount);
    //             let rrr = JSON.stringify(data)
    //             // alert(rrr)
    //             console.log(data.data)
    //             setOrderDetails(data.data);
    //
    //         } catch (error) {
    //             console.error('Ошибка при получении деталей заказа:', error);
    //         }
    //     };
    //     fetchDetails();
    //
    // }, []);
    return (
        <>
            <div key={props.dta._id} style={{
                marginTop: '16px',
                padding: '12px',
                borderLeft: '3px solid #1890ff',
                backgroundColor: '#f6f9ff',
                borderRadius: '6px'
            }}>
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                    <img
                        src={props.dta.product.photo_link}
                        alt="avatar"
                        style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            marginRight: '10px'
                        }}
                    />
                    <div>
                        <div style={{fontWeight: 600}}>{props.dta.author.name}</div>
                        {/*<div style={{fontSize: '12px', color: '#888'}}>*/}
                        {/*    {new Date(props.dta.published_at).toLocaleDateString('ru-RU')}*/}
                        {/*</div>*/}
                    </div>
                </div>
                <div style={{fontSize: '15px'}}>{props.dta.text}</div>
            </div>
            {(props.dta == undefined) ? (
                    <h2><Spin indicator={<LoadingOutlined style={{fontSize: 48}} spin/>}/></h2>) :
                (
                    <>

                        {/*<div style={{paddingTop: "10px"}}>*/}
                        {/*    <Tag color="green-inverse">{orderDetails.visibility}</Tag>*/}
                        {/*</div>*/}

                        <p>
                            {(props.dta.answers?.length < 1) ? (
                                <>
                                    <span style={{fontSize: '17px'}}>Количество ответов: </span>
                                    <Tag color="red-inverse">Нет</Tag>
                                </>
                            ) : (
                                <>
                                    {props.dta.answers?.map((answer, index) => (
                                        <div key={index} style={{
                                            marginTop: '16px',
                                            padding: '12px',
                                            borderLeft: '3px solid #1890ff',
                                            backgroundColor: '#f6f9ff',
                                            borderRadius: '6px'
                                        }}>
                                            <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                                                <img
                                                    src={answer.author.avatar_uri}
                                                    alt="avatar"
                                                    style={{
                                                        width: '36px',
                                                        height: '36px',
                                                        borderRadius: '50%',
                                                        marginRight: '10px'
                                                    }}
                                                />
                                                <div>
                                                    <div style={{fontWeight: 600}}>{answer.author.name}</div>
                                                    {/*<div style={{fontSize: '12px', color: '#888'}}>*/}
                                                    {/*    {new Date(answer.published_at).toLocaleDateString('ru-RU')}*/}
                                                    {/*</div>*/}
                                                </div>
                                            </div>
                                            <div style={{fontSize: '15px'}}>{answer.text}</div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </p>

                    </>
                )}
        </>
    );
};

export default QueDetail;